export default __webpack_public_path__ + "static/media/ideas.4dc55abe.svg";